module.exports = __webpack_public_path__ + "img/banner-side.8e557743.png";